const apiUrl = '/api/v1/intelligence_pc/profile/genre/metric_list';

const params = {
  regions: ['global'],
  entity_type: 'mobile',
  regionType: 'market',
  genre_tab: 'mainsub',
  genreSegment: 'all',
  genre_source: 'iegg',
  granularity: 'monthly',
  start_date: '',
  end_date: '',
  iegg_genre_req: [],
  genre: [],
  // 旧参数，过滤指定的品类，用于折线图
  // 支持多个组合，如主品类则只传主，子则只传子，多个则传多个
  genre_rank: [],
  // 数据源，传appannie或sensortower，以下视情况组合不同的
  source_metrics: {
    appannie: [],
    sensortower: [],
    mscience: [],
    npd: [],
  },
  // 筛选条件，用于内页折线图，视情况使用
  metric_condition: {
    game_ids: [],
    publisher_ids: [],
  },
  // 分组规则，分别是按照date / 国家 / 地区 / 公司 进行分组，视情况使用
  group_by: ['date', 'market', 'region', 'game_id', 'publisher_id'],
  // 支持指标名+排序，环比请传指标名_growth+排序，可支持多个指标，传递此字段的情况，返回值中可以使用rank字段
  order_by: ['revenue desc'],
  use_market_info: [
    'intel_region -> cn',
    'intel_region -> en',
    'region -> cn',
    'region -> en',
  ],
};

// 对应APIList
export const downloadApiListConst = {
  main: {
    api: apiUrl,
    apiParams: params,
  },
  sub: {
    api: apiUrl,
    apiParams: params,
  },
  mainsub: {
    api: apiUrl,
    apiParams: params,
  },
} as any;

export const pageSize = 100000;
const SENSORTOWER = 'sensorTower';

// sheet页签列表
export const sheetNameList = [
  {
    typeName: 'Main Genre',
    typeValue: 'main',
    pipeFrontList: [
      {
        title: 'Genre',
        valueKey: 'genre',
      },
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: SENSORTOWER,
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: SENSORTOWER,
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
    params: {},
  },
  {
    typeName: 'Sub Genre',
    typeValue: 'sub',
    pipeFrontList: [
      {
        title: 'Date',
        valueKey: 'date',
      },
      {
        title: 'Platform',
        valueKey: 'publisher',
        isFixed: true,
      },
      {
        title: 'Sub Genre',
        valueKey: 'publisher_addr',
        isFixed: true,
      },
      {
        title: 'Country_Chinese',
        valueKey: 'publisher_addr_full_name',
        isFixed: true,
      },
      {
        title: 'Country_English',
        valueKey: 'parent_developer',
        isFixed: true,
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: SENSORTOWER,
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: SENSORTOWER,
      },
      {
        title: 'Avg MAU(appannie)',
        valueKey: 'mau',
        source: 'appannie',
      },
      {
        title: 'Avg MAU(sensortower)',
        valueKey: 'mau',
        source: SENSORTOWER,
      },
    ],
    pipeInLoopList: [
      {
        title: 'IEGG Main Genre',
        valueKey: 'IEGG Main Genre',
        isFixed: true,
      },
      {
        title: 'IEGG Sub Genre',
        valueKey: 'IEGG Sub Genre',
        isFixed: true,
      },
    ],
    metricKey: '',
    api: '',
    params: {},
  },
  {
    typeName: 'Main+Sub Genre',
    typeValue: 'mainsub',
    pipeFrontList: [
      {
        title: 'Genre',
        valueKey: 'genre',
        isFixed: true,
      },
      {
        title: 'Countries',
        valueKey: 'countries',
        isFixed: true,
      },
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: SENSORTOWER,
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: SENSORTOWER,
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '',
    params: {},
  },
];
